export default "/images/auth-background-image.svg";